import type { State } from '../../types';

export const selectHasActiveIncidents = (state: State): boolean =>
  (state.unresolvedIncidentsCount || 0) > 0;
